import Link from "next/link";
import React, { useContext, useState, useTransition } from "react";
import helper from "../../lib/helper";
import guestloginModel from "../../models/guestlogin.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import moment from "moment/moment";
const Page = function () {
    const [showLoader, setShowLoader] = useState(false);

    const router = useRouter();
    const queryParams = router.query;
    const { data: guestloginData, mutate: reloadguestloginData, isLoading } = useSWR(
        queryParams || null,
        () => guestloginModel.list(queryParams),
        config.swrConfig
    );

    const columns = [
       
        {
            Header: "Id",
            accessor: "id",
            className: "col"
        },
        
        {
            Header: "Device",
            accessor: "device",
            className: "col"
        },
        
        {
            Header: "Ip address",
            accessor: "ip_address",
            className: "col"
        },
        {
            Header: "Date",
            id: "created_at",
            Cell: ({ row }) => (
                <>
                    <div>
                    {helper.date.format(row.original.created_at)}
                    </div>
                </>
            )
            },
    ];
   

    return (
        <>
            <Heading title="GuestUsers" showLoader={isLoading || showLoader}>
                {console.log()}
            </Heading>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">Guest users List</div>
                    <div className="table-responsive">
                        <Table columns={columns} data={guestloginData?.data || []} />
                    </div>
                    <div className="card-footer">
                        <Pagination meta={guestloginData?.meta} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
